import React from 'react'
import {
  Form,
  Button,
  Segment,
  Header,
  Label,
} from 'semantic-ui-react'
import TypeEditorEnumChoicePane from './TypeEditorEnumChoicePane.js'

// Note: Form.Field containing a ButtonGroup didn't work
//       (and there is no Form.ButtonGroup),
//       so I used SUI (not SUI React) to put the buttons
//       in the right-most column of the Form.Group
//       (i.e., <div className='nine wide field'>...)
class TypeEditorEnumPane extends React.Component {
  // props:
  // enu
  // onSetEnumId: newId=>...
  // onSetEnumName: newName=>...
  // onSetEnumDescription: newDescription=>...
  // onRemoveEnum: ()=>...
  // onAddEnumChoice: ()=>...
  // onSetEnumChoiceId: (ci, newId)=>...
  // onSetEnumChoiceName: (ci, newName)...
  // onSetEnumChoiceDescription: (ci, newDescription)=>...
  // onSetEnumChoiceColor: (ci, newColor)=>...
  // onSetEnumChoiceIcon: (ci, newIcon)=>...
  // onRemoveEnumChoice: ci=>...
  render() {
    //console.log("TypeEditorEnumPane::render()");
    //console.log("this.props:", this.props);
    return (
      <Segment>
        <Header as='h3'>Enumeration</Header>
        <Label
          attached='top right'
          color='red'
          onRemove={this.props.onRemoveEnum}
        />
        <Form.Group>
          <Form.Input
            width={2}
            name='id'
            label='ID'
            value={this.props.enu.id}
            placeholder='Unique ID of this enum'
            onChange={(e, { value })=>this.props.onSetEnumId(value)}
          />
          <Form.Input
            width={6}
            name='name'
            label='Name'
            value={this.props.enu.name}
            placeholder='Descriptive name of this enum'
            onChange={(e, { value })=>this.props.onSetEnumName(value)}
          />
          <div className='nine wide field'>
            <label>&nbsp;</label>
            <div className='ui icon buttons right floated'>
              {
                this.props.enu.choices.map((c,i)=>
                  <button
                    key={i}
                    type='button'
                    className={c.color+' ui icon button'}
                  >
                    <i className={c.icon+' icon '}/>
                  </button>
                )
              }
            </div>
          </div>
        </Form.Group>
        <Form.TextArea
          name='description'
          label='Description'
          value={this.props.enu.description}
          placeholder='Description of this enumeration'
          onChange={(e, { value })=>this.props.onSetEnumDescription(value)}
        />
        {
          this.props.enu.choices.map((c,ci)=>
            <TypeEditorEnumChoicePane
              key={ci}
              choice={c}
              onSetEnumChoiceId={newId=>this.props.onSetEnumChoiceId(ci, newId)}
              onSetEnumChoiceName={newName=>this.props.onSetEnumChoiceName(ci, newName)}
              onSetEnumChoiceDescription={newDescription=>this.props.onSetEnumChoiceDescription(ci, newDescription)}
              onSetEnumChoiceColor={newColor=>this.props.onSetEnumChoiceColor(ci, newColor)}
              onSetEnumChoiceIcon={newIcon=>this.props.onSetEnumChoiceIcon(ci, newIcon)}
              onRemoveEnumChoice={()=>this.props.onRemoveEnumChoice(ci)}
            />
          )
        }
        <Button type='button' color='orange' onClick={this.props.onAddEnumChoice}>Add Choice</Button>
      </Segment>
    );
  }
}

export default TypeEditorEnumPane